import { useEffect } from "react";

export function useAutoscrollOnResize(
  ref: React.RefObject<HTMLElement>,
  enabled: boolean
) {
  useEffect(() => {
    const el = ref.current;
    if (!el || !enabled) return;

    let last = el.scrollHeight;
    const toBottom = () =>
      requestAnimationFrame(() =>
        el.scrollTo({ top: el.scrollHeight, behavior: "smooth" })
      );

    const ro = new ResizeObserver(() => {
      const now = el.scrollHeight;
      if (now > last) {
        last = now;
        toBottom();
      }
    });

    ro.observe(el);

    const mo = new MutationObserver(() => toBottom());
    mo.observe(el, { childList: true, subtree: true });

    toBottom();
    return () => {
      ro.disconnect();
      mo.disconnect();
    };
  }, [ref, enabled]);
}
